/* Utils */
import { Carousel } from '../models';
import {
  generateSelectEntityById,
  generateSelectEntitiesByIdsList,
  generateSelectEntitiesByEntitiesList,
  generateSelectEntityByEntityInfo,
} from '../utils/generators/selectorGenerators';

export const selectAllCarousels = (state) => state.carousels;
export const selectCarouselById = generateSelectEntityById(selectAllCarousels);
export const selectCarouselByCarouselInfo = generateSelectEntityByEntityInfo(
  selectAllCarousels,
  Carousel,
);
export const selectCarouselsListByIdsList = generateSelectEntitiesByIdsList(selectAllCarousels);
export const selectCarouselsListByCarouselInfoList = generateSelectEntitiesByEntitiesList(
  selectAllCarousels,
  Carousel,
);
